(function () {
  if (window.__freeGiftInit) return;
  window.__freeGiftInit = true;

  var OPT_OUT_KEY = 'eszterkrem:free-gift-opt-out';
  var config = window.freeGiftConfig;
  if (!config || !config.enabled || !config.variantId || !config.productId) return;
  if (!window.routes || !window.routes.cart_url) return;

  var busy = false;
  var lastHadGift = null;

  function jsonHeaders() {
    return {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    };
  }

  function getCart() {
    return fetch(window.routes.cart_url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('cart fetch failed');
      return res.json();
    });
  }

  function qualifyingCents(cart) {
    var total = 0;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].product_id === config.productId) continue;
      total += items[i].final_line_price != null ? items[i].final_line_price : items[i].line_price;
    }
    return total;
  }

  function findGiftLine(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === config.variantId) return items[i];
    }
    return null;
  }

  function isOptedOut() {
    try {
      return localStorage.getItem(OPT_OUT_KEY) === String(config.variantId);
    } catch (err) {
      return false;
    }
  }

  function setOptOut() {
    try {
      localStorage.setItem(OPT_OUT_KEY, String(config.variantId));
    } catch (err) {}
  }

  function clearOptOut() {
    try {
      if (localStorage.getItem(OPT_OUT_KEY) === String(config.variantId)) {
        localStorage.removeItem(OPT_OUT_KEY);
      }
    } catch (err) {}
  }

  function updateBubble(count) {
    var bubble = document.getElementById('CartBubble');
    if (!bubble) return;
    bubble.textContent = count > 0 ? String(count) : '';
    bubble.classList.toggle('hidden', count < 1);
  }

  function refreshCartUi(cart) {
    if (cart && typeof cart.item_count === 'number') {
      updateBubble(cart.item_count);
    }

    // Full cart page: reload so line items stay in sync
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return Promise.resolve();
    }

    var modal = document.querySelector('cart-modal');
    if (modal && typeof modal.reloadContent === 'function') {
      return modal.reloadContent().catch(function () {});
    }
    return Promise.resolve();
  }

  function addGift() {
    return fetch(window.routes.cart_add_url, Object.assign({}, jsonHeaders(), {
      body: JSON.stringify({
        id: config.variantId,
        quantity: 1,
        sections: ['cart-bubble']
      })
    })).then(function (res) {
      if (!res.ok) throw new Error('gift add failed');
      return res.json();
    });
  }

  function removeGiftLine(line) {
    return fetch(window.routes.cart_change_url, Object.assign({}, jsonHeaders(), {
      body: JSON.stringify({
        id: String(line.key),
        quantity: 0,
        sections: ['cart-bubble']
      })
    })).then(function (res) {
      if (!res.ok) throw new Error('gift remove failed');
      return res.json();
    });
  }

  function sync(options) {
    options = options || {};
    if (busy) return Promise.resolve();
    busy = true;

    return getCart()
      .then(function (cart) {
        var giftLine = findGiftLine(cart);
        var hadGift = !!giftLine;
        var qualifying = qualifyingCents(cart);
        var eligible = qualifying >= config.thresholdCents;

        // Manual remove while still eligible → opt out
        if (lastHadGift === true && !hadGift && eligible) {
          setOptOut();
        }
        lastHadGift = hadGift;

        // Manual add clears opt-out
        if (hadGift && isOptedOut()) {
          clearOptOut();
        }

        if (eligible && !hadGift && !isOptedOut()) {
          return addGift().then(function () {
            return getCart();
          }).then(function (nextCart) {
            lastHadGift = !!findGiftLine(nextCart);
            return refreshCartUi(nextCart).then(function () {
              return nextCart;
            });
          });
        }

        if (!eligible && hadGift) {
          return removeGiftLine(giftLine).then(function () {
            return getCart();
          }).then(function (nextCart) {
            lastHadGift = !!findGiftLine(nextCart);
            return refreshCartUi(nextCart).then(function () {
              return nextCart;
            });
          });
        }

        if (options.refreshUi) {
          return refreshCartUi(cart).then(function () {
            return cart;
          });
        }

        return cart;
      })
      .catch(function () {})
      .then(function (result) {
        busy = false;
        return result;
      });
  }

  function isCartMutationUrl(url) {
    if (!url) return false;
    var path = String(url);
    return (
      path.indexOf('/cart/add') !== -1 ||
      path.indexOf('/cart/change') !== -1 ||
      path.indexOf('/cart/update') !== -1 ||
      path.indexOf('/cart/clear') !== -1
    );
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var input = arguments[0];
    var url = typeof input === 'string' ? input : input && input.url;
    return originalFetch.apply(this, arguments).then(function (response) {
      if (!busy && isCartMutationUrl(url || (response && response.url))) {
        // Defer so theme handlers finish section updates first
        setTimeout(function () {
          sync();
        }, 0);
      }
      return response;
    });
  };

  document.addEventListener('product:added-to-cart', function () {
    setTimeout(function () {
      sync();
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sync();
    });
  } else {
    sync();
  }
})();
